var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.28947V13.5C0.5 14.0523 0.947715 14.5 1.5 14.5H12.5C13.0523 14.5 13.5 14.0523 13.5 13.5V6.28947M0.5 6.28947V3.86842C0.5 3.31614 0.947715 2.86842 1.5 2.86842H4.26316M0.5 6.28947H13.5M13.5 6.28947V3.86842C13.5 3.31614 13.0523 2.86842 12.5 2.86842H9.73684M4.26316 1.5V2.86842M4.26316 2.86842V4.23684M4.26316 2.86842H9.73684M9.73684 1.5V2.86842M9.73684 2.86842V4.23684",
    stroke: "#424895",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.3H10.4667",
    stroke: "#424895",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5332 11.9L10.4665 11.9",
    stroke: "#424895",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMobile);
export default __webpack_public_path__ + "static/media/calendar-mobile.8a1bd5cbb93c872130582ef83089fe6b.svg";
export { ForwardRef as ReactComponent };